import useMediaQuery from "./useMediaQuery";

const useBreakpoint = () => {
  const isSmall = useMediaQuery("(max-width: 575px)");
  const isTab = useMediaQuery("(min-width: 576px) and (max-width: 767px)");
  const isMedium = useMediaQuery("(min-width: 576px) and (max-width: 991px)");
  const isLarge = useMediaQuery("(min-width: 992px) and (max-width: 1299px)");
  const isXLarge = useMediaQuery("(min-width: 1300px)");

  if (isSmall) return "sm";
  if (isTab) return "tb";
  if (isMedium) return "md";
  if (isLarge) return "lg";
  if (isXLarge) return "xl";

  return "unknown";
};

export default useBreakpoint;
